export default __webpack_public_path__ + "static/media/kitchen3-afterA-2048w.e4e20c76.webp";